import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

export default function WaysToWork() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Ways to Work Together
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Two Ways to Work With Josh
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Reveal delay={0}>
            <div className="h-full flex flex-col rounded-2xl border border-white/10 bg-background-50 p-8">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 text-primary-400 px-3 py-1 text-xs font-label font-semibold">
                <i className="ri-rocket-line"></i>
                Done For You
              </span>
              <h3 className="mt-5 font-heading font-bold text-xl text-foreground-950">
                Done For You Marketing
              </h3>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                For businesses that want the strategy and implementation handled
                end to end.
              </p>
              <div className="mt-auto pt-6 border-t border-white/5">
                <Link
                  to="/#work-with-josh"
                  className="inline-flex items-center gap-2 whitespace-nowrap font-label font-semibold text-sm text-primary-400 hover:text-primary-300 transition-colors">
                  Explore DFY
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="h-full flex flex-col rounded-2xl border border-white/10 bg-background-50 p-8">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                <i className="ri-user-star-line"></i>
                Done With You
              </span>
              <h3 className="mt-5 font-heading font-bold text-xl text-foreground-950">
                Done With You Consulting
              </h3>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                For established teams that want Josh&rsquo;s guidance,
                direction, and optimization.
              </p>
              <div className="mt-auto pt-6 border-t border-white/5">
                <Link
                  to="/#work-with-josh"
                  className="inline-flex items-center gap-2 whitespace-nowrap font-label font-semibold text-sm text-accent-400 hover:text-accent-300 transition-colors">
                  Explore DWY
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal className="mt-10 text-center">
          <p className="text-foreground-600">
            Not sure which is right for you?
          </p>
          <p className="mt-2 font-heading font-semibold text-foreground-950">
            Apply and we&rsquo;ll help determine the best fit.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
